<template>
  <Form :exhibit="exhibit" @exhibit-action="createExibit" />
</template>

<script>
import axios from 'axios'
import Form from '@/pages/admin/exhibits/form'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  components: {
    Form
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: 'ギャラリー作成',
      exhibit: {
        published: 1,
        priority: 0,
        exhibitableId: null,
        exhibitableType: null,
        imagableUrl: null,
        imageDirectUrl: null,
        exhibitRelatedPostsAttributes: [],
        imageSourceUrl: ''
      }
    }
  },
  methods: {
    createExibit () {
      axios.post('/api/exhibits', { exhibit: this.exhibit }).then(
        () => {
          this.exhibit = {
            published: 1,
            priority: 0,
            exhibitableId: null,
            exhibitableType: null,
            exhibitRelatedPostsAttributes: [],
            imageSourceUrl: ''
          }
          const payload = {
            status: 200,
            message: '作成しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    }
  }
}
</script>
